{
  "eyebrow": "Facturación y pago",
  "title": "Ya casi.",
  "sub": "Continúa al pago seguro para iniciar tu prueba de 30 días. No se te cobrará hoy.",
  "summary": {
    "company": "Empresa",
    "plan": "Plan",
    "cycle": "Ciclo de facturación",
    "users": "Usuarios",
    "vtt": "Vehicle Track & Trace",
    "vehicles": "Vehículos",
    "total": "Total estimado / mes",
    "vttOn": "Incluido"
  },
  "secureNote": "Pago seguro vía Stripe · Prueba gratis 30 días · Cancela cuando quieras",
  "continue": "Continuar a Stripe",
  "submitting": "Abriendo Stripe…",
  "canceled": {
    "title": "Pago cancelado",
    "sub": "No se realizó ningún cargo. Inténtalo de nuevo o contáctanos si necesitas ayuda.",
    "retry": "Reintentar"
  },
  "promo": {
    "toggle": "¿Tienes un código promocional?",
    "placeholder": "Código promocional",
    "apply": "Aplicar",
    "chip": "{{percent}}% de descuento",
    "remove": "Quitar código promocional",
    "errorGeneric": "No se pudo verificar el código. Inténtalo de nuevo."
  },
  "errors": {
    "generic": "No se pudo iniciar el pago. Inténtalo de nuevo."
  },
  "totalUnavailable": "Catálogo de precios no disponible. Reintenta para cargar los precios más recientes."
}
